<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      客保证金管理
      <small>/保证金管理列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">保证金管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <el-row>
                      <el-form ref="form" :model="form" label-width="90px" style="width: 80%;">
                        <el-col :span="8">
                          <div class="grid-content bg-purple">
                            <el-form-item label="合同编号：" class="btn1">
                              <el-input v-model="form.contractNo" placeholder="请输入合同编号"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8" style="padding-left:20px;">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="合同标题：" class="btn1">
                              <el-input v-model="form.contractTitle" placeholder="请输入合同标题"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple">
                            <el-form-item label="服务商：" class="btn1">
                              <!-- <el-input v-model="form.recomName" placeholder="请输入服务商名称"></el-input> -->
                              <el-select
                                v-model="form.recomName"
                                style="width:100%"
                                clearable
                                filterable
                                placeholder="请输入服务商名称"
                              >
                                <el-option
                                  v-for="item in recomNameList"
                                  :key="item.recomId"
                                  :label="item.recomName"
                                  :value="item.recomId"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-form>
                    </el-row>
                  </div>

                  <div class="top-bot">
                    <el-form ref="Formdata" :model="Formdata" :rules="rules" label-width="80px">
                      <el-form-item label="订单时间: " prop="TimeValue">
                        <el-date-picker
                          v-model="Formdata.TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                          align="center"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="bot-btn">
                    <el-button class="btn btn-primary btn-sm ButtonColor" @click="chaxun()">查询</el-button>
                    <el-button class="btn btn-primary btn-sm ButtonColor" @click="addc()">新增合同</el-button>
                    <el-button class="btn btn-primary btn-sm ButtonColor bot-btn-left"  @click="exp()">导出</el-button>
                  </div>
                  <!-- 03 -->
                  <div style="width:100%">
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="150"
                        prop="contractNo"
                        label="合同编号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="contractTitle"
                        label="合同标题"
                        align="center"
                        resizable
                      ></el-table-column>

                      <el-table-column
                        width="100"
                        prop="depositScope"
                        label="合同区域"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="goodsName"
                        label="合同品类"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="recomTypeName"
                        label="客户类型"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="recomName"
                        label="客户名称"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="inputTime"
                        label="客户签订时间"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="depositTime"
                        label="企业签订时间"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="180"
                        prop="contractFileUrl"
                        label="合同下载地址"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column width="345" label="操作" align="center" resizable>
                        <template slot-scope="scope">
                          <el-button class="btn btn-primary btn-sm ButtonColor"  @click="edit(scope.row)">审核</el-button>
                          <el-button
                            @click="handleClick(scope.row,scope.$index+1)"
                            class="btn btn-primary btn-sm ButtonColor"
                          >合同详情</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title :visible.sync="outerVisible" :before-close="handleClose" width="50%">
        <!-- 编辑和  新增 -->
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>

          <!-- 新增 -->
          <el-form
            :model="ruleForm"
            :inline="true"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
          >
            <el-form-item label="合同编号:" prop="contractNo" class="labelstyle">
              <el-input
                v-model="ruleForm.contractNo"
                class="DistributorMargin InputWidth"
                style="width:100%"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同标题:" prop="contractTitle" class="labelstyle">
              <el-input v-model="ruleForm.contractTitle" class="DistributorMargin InputWidth"></el-input>
            </el-form-item>
            <el-form-item label="合同区域:" prop="contractScopeName" class="labelstyle">
              <el-input v-model="ruleForm.contractScopeName" class="DistributorMargin InputWidth"></el-input>
            </el-form-item>
            <el-form-item label="合同品类:" prop="goodsName" class="labelstyle">
              <el-select
                v-model="ruleForm.goodsName"
                clearable
                placeholder="请选择"
                class="DistributorMargin InputWidth"
              >
                <el-option
                  v-for="item in GroupList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型:" prop="recomTypeName" class="labelstyle">
              <el-select
                v-model="ruleForm.recomTypeName"
                clearable
                placeholder="请选择"
                class="DistributorMargin InputWidth"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称:" prop="recomName" class="labelstyle">
              <el-input
                v-model="ruleForm.recomName"
                autocomplete="new-password"
                class="DistributorMargin InputWidth"
              ></el-input>
            </el-form-item>
            <div class="clear"></div>
            <div class="upload">
              <div class="upload_left">上传合同：</div>
              <div>
                <!-- 后端接口 -->
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :headers="headers"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-error="handleErr"
                  :on-success="handleSuccess"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </div>
            <div class="upload">
              <div class="upload_left">备注：</div>
              <div class="upload_right">
                <el-input
                  v-model="ruleForm.bz"
                  type="textarea"
                  class="DistributorMargin InputWidth"
                ></el-input>
              </div>
            </div>
          </el-form>

          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--cancel btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >提交</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-primary"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
        <!-- 审核对话框    嵌套的对话框-->

        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <div class="border-main">
            <h5>你确定保证金的金额与合同一致</h5>
          </div>

          <!-- <el-dialog width="30%" title="内层 Dialog" :visible.sync="innerVisible" append-to-body>
            <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          </el-dialog>-->
          <div slot="footer" class="dialog-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--cancel btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >同意审核</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-primary"
                @click="jujue('ruleForm')"
              >拒绝审核</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "auditdeposit",
  data() {
    var checkcontractNo = (rule, value, callback) => {
      setTimeout(() => {
        var reg = /^[0-9A-Za-z]{1,16}$/;
        if (!reg.test(value)) {
          callback(new Error("合同编号由数字和字母组成且小于16位"));
        } else {
          callback();
        }
      }, 1000);
    };
    /*
    var checkrecomName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };
    // 合同区域
    var checkarea = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };
 */
    return {
      // 上传合同，
      dialogImageUrl: "",
      dialogVisible: false,
      //  直接从本地获取token就行
      headers: {
        Authorization: JSON.parse(localStorage.getItem("Authorization"))
          .Authorization
      },
      // 对话框
      outerVisible: false,
      innerVisible: false,
      DialogTitle: "编辑",
      disabled: false,
      EditDialog: 1,
      CurrentSelection: [],
      //
      ruleForm: {
        contractId: 1,
        contractNo: "",
        contractTitle: "",
        contractScopeName: 1,
        signTime: "",
        goodsName: "",
        recomTypeName: "",
        recomName: "",
        contractFileUrl: "",
        contractTerm: "",
        contractStatus: 0,
        status: 1,
        groupId: ""
      },
      // 当前页  ---- 默认显示第几页
      // current: 1,
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,

      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      //
      form: {
        contractNo: "",
        contractTitle: "",
        recomName: ""
      },
      // 列表服务商名称
      recomNameList: [],
      rules: {
        TimeValue: [
          {
            required: false,
            message: "请选择查询时间",
            trigger: "change"
          }
        ],
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { validator: checkcontractNo, trigger: "blur" }
        ]
        // contractTitle: [
        //   { required: true, message: "请输入合同标题", trigger: "blur" }
        //   // { validator: checkrecomName, trigger: "blur" }
        // ],
        // // 合同区域
        // contractScopeName: [
        //   { required: true, message: "请输入合同区域", trigger: "blur" }
        //   // { validator: checkarea, trigger: "blur" }
        // ],
        // //  客户名称
        // recomName: [
        //   { required: true, message: "请输入客户名称", trigger: "blur" }
        //   // { validator: checkrecomName, trigger: "blur" }
        // ],
        // // 合同品类
        // goodsName: [{ required: true, message: "请选择", trigger: "change" }],
        // //客户类型
        // recomTypeName: [{ required: true, message: "请选择客户类型", trigger: "change" }]
      },

      // 新增品类
      GroupList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      // 合同类型
      typeList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      Formdata: {
        // TimeValue: [new Date(2020, 0, 1), new Date()]
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: [],
      depositStatus: [
        {
          key: 0,
          value: "驳回"
        },
        {
          key: 1,
          value: "未审核"
        },
        {
          key: 2,
          value: "审核通过"
        }
      ],
      director:0
      //
    };
  },
  created() {},
  mounted() {
       // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initData();
    this.initDatarecomNameList();
  },
  methods: {
    // 初始化数据
    initData() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobDepositController/queryDepositByPage",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          // that.form.contractNo
          // 合同编号
          contractNo: that.form.contractNo,
          // 合同标题
          contractTitle: that.form.contractTitle,
          // 服务商id
          // recomId:1,
          //  运营标识：1-运营总监 2-普通运营
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.records.length; i++) {
            //  goodsid  为  自定义  属性 --- 【序号】
            response.data.data.records[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }
          if (response.data.data.records.length > 0) {
            for (var value of response.data.data.records) {
              value.depositScope = value.province + " " + value.city;
            }
            this.tableData3 = response.data.data.records;
            this.totalCount = response.data.data.total;
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },

    // 服务商 名称
    initDatarecomNameList() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          //  运营标识：1-运营总监 2-普通运营
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          this.recomNameList = response.data.data;
          this.addrecomNameList = response.data.data;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 查询数据
    chaxun() {
      this.initData();
      // this.pageNo = 1
    },
    addc() {
      console.log("新增合同 ");
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 事件处理函数
    MakeSureEdit(formName) {
      if (this.DialogTitle === "审核") {
        let that = this;
        that.outerVisible = false;
        that.disabled = false;
        const options = {
          url: "/distribution/B2cTobDepositController/checkDeposit",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            depositStatus: 2,
            depositId: that.ruleForm.depositId
          })
        };
        axios(options)
          .then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code == 200) {
              that.initData();
              that.$notify({
                title: "成功",
                message: "审核成功",
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            that.outerVisible = false;
            that.disabled = false;
            http.handleHttpError(error, that);
          });

        //
      } else if (this.DialogTitle === "新增") {
        console.log("新增");
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/addDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                // 合同编号
                contractNo: that.ruleForm.contractNo,
                // 保障金
                deposit: that.ruleForm.deposit,
                // 缴纳时间
                depositTime: that.ruleForm.depositTime,
                
                fileUrl: that.dialogImageUrl
              })
            };
            axios(options)
              .then(function(response) {
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  that.disabled = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    jujue(formName) {
      this.innerVisible = true;
      // this.outerVisible = false;
      this.$prompt("理由：", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /./g,
        inputPlaceholder: "请输入拒绝审核理由",
        inputErrorMessage: "请输入拒绝审核理由"
      })
        .then(({ value }) => {
          let that = this;
          that.outerVisible = false;
          that.disabled = false;
          const options = {
            url: "/distribution/B2cTobDepositController/checkDeposit",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              depositStatus: 0,
              depositId: that.ruleForm.depositId,
              depositRemark: value
            })
          };
          axios(options)
            .then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initData();
                that.$notify({
                  title: "成功",
                  message: "拒绝审核",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response, that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });

          this.outerVisible = false;
        })
        .catch(() => {
          this.outerVisible = true;
        });
    },
    // 上传合同的处理函数
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      console.log(response);
    },
    handleErr(err, file, fileLis) {
      console.log(err);
    },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/statistics/purchaseController/queryExcelPurchaseInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // 请求参数
        data: Qs.stringify({
          //  开始时间
          beginTime: that.startTime,
          // 结束时间  （yyyy-MM-dd HH:mm:ss）
          endTime: that.endTime
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          }
        })
        .catch(error => {
          http.handleHttpError(error, this);
        });
    },
    // 详情的处理函数
    handleClick(row, index) {
      this.$router.push({
        name: "depositdetail",
        path: "/depositdetail",
        query: { depositId: row.depositId }
      });
    },
    // 审核函数
    edit(item) {
      this.outerVisible = true;
      this.DialogTitle = "审核";
      this.EditDialog = 2;
      this.ruleForm = MethodsBus.cloneRow(item);
      // this. depositId  =   item.depositId
    },
    // 对话框的 【确定 】 处理函数
    // MakeSure() {
    //   this.outerVisible = true;
    // },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.border-main {
  border: 1px solid #ddd;
  border-radius: 5px;
  float: left;
  padding: 12% 6%;
  margin: 3% 22%;
  margin-top: 0;
  width: 60%;
}

.upload {
  margin-top: 20px;
  margin-left: 17%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  margin-top: 50px;
  padding-right: 20px;
  letter-spacing: 1px;
}
.upload_right {
  margin-top: 45px;
}
.item {
  margin-bottom: 18px;
}
.swal-footer {
  text-align: center;
}
.swal-button-container {
  margin-left: 24px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}
.bot-btn {
  float: left;
  margin-left: 42%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
.el-form-item {
  margin-bottom: 40px;
  padding-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/auditdeposit.vue